import { useMutation } from "@apollo/client";
import { DELETE_MANDATE } from "../../../Schema/Mandate";
import { useContext, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";

export const useDeleteMandate = ({ handleClose, setRefetch }) => {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteMandate] = useMutation(DELETE_MANDATE, {
    onCompleted: ({ deleteMandate }) => {
      setLoading(false);
      if (deleteMandate?.isSuccess === true) {
        setAlert(true, "success", deleteMandate?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteMandate?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = (id) => {
    deleteMandate({
      variables: {
        id: id,
      },
    });
  };

  return { handleDelete, loading };
};
